<template>
	<div class="stop-selector-dropdown">
        <div class="dropdown__header">
            <div class="form-row align-items-center">
                <div class="col-auto">
                    <span class="dropdown__icon">
                        <img :src="stopType === 'from'? require('@/assets/icons/from-a.svg') : require('@/assets/icons/to-b.svg')" :alt="stopType === 'from'? $t('Honnan') : $t('Hova')" />
                    </span>
                </div>
                <div class="col">
                    {{ stopType === 'from'? fromStopIndex === null? $t('Honnan') : stops[fromStopIndex].stopName : toStopIndex === null? $t('Hova') : stops[toStopIndex].stopName }}
                </div>
                <div class="col-auto">
                    <button @click="closeDropdown()" class="dropdown__close"><img src="@/assets/icons/close.svg" :alt="$t('Bezárás')"></button>
                </div>
            </div>
        </div>

        <div class="dropdown__content">
            <RouteStopSelector :stops="stops" :single="true" :singleType="stopType" :fromStopIndex="fromStopIndex" :toStopIndex="toStopIndex" @selectStop="selectStop"></RouteStopSelector>
        </div>
	</div>
</template>

<script>
import RouteStopSelector from '@/components/RouteStopSelector'
export default {
    name: "RouteStopSelectorDropdown",
    components: {
        RouteStopSelector
    },
	props: {
        stopType: {
            type: String,
            default: 'from'
        },
		stops: {
			type: Array,
			require: true,
		},
		fromStopIndex: {
			type: [String, Number],
			require: true,
		},
		toStopIndex: {
			type: [String, Number],
			require: true,
        }
	},
	data() {
		return {};
	},
	methods: {
        closeDropdown: function() {
            this.$emit("closeDropdown");
        },
		selectStop: function (data) {
            this.$emit("selectStop", { stop: data.stop, index: data.index, single: true, singleType: this.stopType });
            this.closeDropdown();
		},
	},
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/__variables.scss";

.stop-selector-dropdown {
    border-radius:$radius1;
    background-color:white;
    position: absolute;
    left:0;
    right:0;
    top:0;
    z-index: 1;
    box-shadow: 0px 0px 3000px 3000px rgba(0,0,0,.2);
}

.dropdown__header {
    border-bottom:1px solid $grey6;
    padding:0 7px;

    > .form-row {
        height:55px;
    }
}

.dropdown__close {
    border:0;
    background-color:transparent;
    width: 30px;
    height:30px;
    cursor:pointer;
}

</style>
